import React, { Component } from 'react'
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';


export default class ViewStage1AuditReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
              orgCode: props.match.params.orgcode,
        data: {},     
        isLoading:false
        }       
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    componentDidMount() {
        const api=APIURL + '/api/rfq/get/orgdetails/' + this.state.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
            .then(res => {
                console.log("res",res.data.response)
                if(res.data.errorCode === 0){
                    this.setState({data : res.data.response})
        
                }
            })
            .catch(e=>{
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);

                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                    //alert("if")
                    this.setState({isLoading:true})
                }
            })
    }

    handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+ '/stage1auditreport/' +this.state.orgCode;
    }

    render() {
       
    if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
    return (
        <div>
           
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                           
                            <div className="col-sm-12">
                                <div className="card-body" style={{ paddingLeft: "50px" }}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Company Name</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Address</label>
                                                    <div className="col-sm-9">
                                                    <p>{this.state.data.address}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Site Address</label>
                                                    <div className="col-sm-9">
                                                    <p>{this.state.data.siteofaddress}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of Employees</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.total}</p>
                                                    </div>

                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date of Audit</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.dateofaudit}</p>               
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Mobile</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.mobile}</p>                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Email</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.email}</p>                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No of Server</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.noofserver}</p> 
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Number of WS+PC+Laptop</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.noofwspclp}</p> 
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">DataCenter  Details(If Present)</label>
                                                    <div className="col-sm-9">
                                                    <p>{this.state.data.datacenterdetails}</p>                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No of Application user</label>
                                                    <div className="col-sm-3">
                                                    <p>{this.state.data.noofappluser}</p>                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No of Infrastructure user(Pc/laptop etc)</label>
                                                    <div className="col-sm-3">
                                                    <p >{this.state.data.noofinfrauser}</p>                                                    
                                                    </div>
                                                </div>
                                                
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize mt-3">Audit Findings</label>
                                                    {
                                                        this.state.data && this.state.data.processAuditReportDetails && this.state.data.processAuditReportDetails.length > 0 ?
                                                            this.state.data.processAuditReportDetails.map((item, index) => {
                                                                return (
                                                                    <div className="mt-4">
                                                                        <table key={index}>
                                                                            <tr >
                                                                                <td style={{width:"20%"}}> Name Of Process </td>
                                                                                <td>{item.nameofprocess}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{width:"20%"}}>Process Owner </td>
                                                                                <td>{item.processowner}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{width:"20%"}} >Reference</td>
                                                                                <td colSpan="3">{item.reference}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{width:"20%"}}>Details</td>
                                                                                <td colSpan="3" dangerouslySetInnerHTML={{ __html: item.details }}></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{width:"20%"}}>Auditor comments on</td>
                                                                                <td colSpan="3">{item.comments}</td>



                                                                            </tr>
                                                                            <tr>
                                                                                <td>Clauses Details</td>
                                                                                <td colSpan="3">
                                                                                  

                                                                                                    <table className="table ">
                                                                                                        <thead >
                                                                                                            <tr>

                                                                                                                <td scope="col" className="text-center" style={{ "width": "180px" }}>Clause </td>
                                                                                                                <td scope="col" className="text-center" style={{ "width": "120px" }}> Observation</td>
                                                                                                            </tr> 
                                                                                                            </thead>
                                                                                                            {
                                                                                        item.clauseWiseObservation ?
                                                                                            item.clauseWiseObservation.map((subitem, subindex) => {
                                                                                                return (
                                                                                                        <tbody key={subindex}>


                                                                                                            <tr>
                                                                                                                <td style={{ "width": "60px" }}>{subitem.clauseNo}</td>
                                                                                                                <td style={{ "width": "120px" }}>{subitem.Observation}</td>


                                                                                                            </tr>

                                                                                                        </tbody>
                                                                                                          )
                                                                                                        })
                                                                                                        :
                                                                                                        <>No Nace Code data addded</>
                                                                                                }
                                                                                                    </table>

                                                                                              

                                                                                </td>



                                                                            </tr>

                                                                        </table>
                                                                        <br />

                                                                    </div>
                                                                )
                                                            }
                                                            ) : <>No Data Found</>
                                                    }
                                                </div>
                                            <div className="card-footer">
                                                <div className="row">
                                                    <div className="col-sm-10"></div>
                                                    <div className="col-sm-2">

                                                        <button className="btn btn-primary float-right ml-5" onClick={() => { this.handleRoute() }}>Edit</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        
    )
}

}
